import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-full text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-accent px-5 py-3 text-accent-foreground shadow-[var(--shadow-accent)] hover:bg-[var(--accent-hover)]",
        secondary:
          "bg-white/70 px-5 py-3 text-foreground ring-1 ring-border hover:bg-white",
        ghost:
          "px-3 py-2 text-muted-foreground hover:bg-muted hover:text-foreground",
        destructive:
          "bg-destructive px-5 py-3 text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-border bg-background px-5 py-3 text-foreground hover:bg-muted",
      },
      size: {
        default: "h-11",
        sm: "h-9 px-4 text-xs uppercase tracking-[0.24em]",
        lg: "h-12 px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);

Button.displayName = "Button";

export { Button, buttonVariants };
